import { db } from './firebase';

// User API
export const doCreateUser = (id, username, email, inGameName) =>
  db.collection("users").doc(id).set({
    username: username,
    inGameName: inGameName,
    email: email,
    favorites: []
  })
  .then(function() {
      console.log("Document successfully written!");
  })
  .catch(function(error) {
      console.error("Error writing document: ", error);
  });

export const getUser = (id) =>
db.collection("users").doc(id).get().then(function(doc) {
  if (doc.exists) {
      return doc.data();
  } else {
      console.log("No such document!");
  }
});

export const updateUser = (id, inGameName, ethWallet) =>
  db.collection("users").doc(id).update({
    inGameName: inGameName,
    ethWallet: ethWallet
}).then(function() {
    console.log("Document successfully updated!");
})
.catch(function(error) {
    console.error("Error updating document: ", error);
});

export const updateUserFavorites = (id, favorites) =>
  db.collection("users").doc(id).update({
    favorites: favorites
  }).then(function() {
      console.log("Document successfully updated!");
  })
  .catch(function(error) {
      console.error("Error updating document: ", error);
  });

export const getUserDecks = (user) =>
 db.collection("deckDetails").where("author", "==", user)
.get().then(function(querySnapshot) {
  var decklist = [];
  querySnapshot.forEach(function(doc) {
      decklist.push(
        {"id": doc.id,
        "deckName": doc.data().deckName,
        "aspects": ("aspects" in doc.data() ? doc.data().aspects : []),
        "addDate": ("addDate" in doc.data() ? doc.data().addDate : new Date())
      });
});
  return decklist;
});

// Article APIs
export const postArticle = (articleId, articleName, articleDetails, author, date) =>
  db.collection("articles").doc(articleId).set({
      articleName: articleName,
      article: articleDetails,
      author: author,
      date: date
  })
  .then(function() {
      console.log("Document successfully written!");
  })
  .catch(function(error) {
      console.error("Error writing document: ", error);
  });

export const postComment = (articleId, commentObj) =>
  db.collection("articles").doc(articleId).update({
    Comments: commentObj
  }).then(function() {
      console.log("Document successfully updated!");
  })
  .catch(function(error) {
      console.error("Error updating document: ", error);
  });

export const getComments = (articleId) =>
  db.collection("articles").doc(articleId).get().then(function(doc) {
    if (doc.exists) {
      return doc.data();
    } else {
      console.log("No such document!");
    }
  });

// Deck APIs
export const getDeck = (deckId) =>
  db.collection("deckDetails").doc(deckId).get().then(function(doc){
    if (doc.exists) {
      return doc.data();
    } else {
      console.log("Deck not found!");
    }
  })

export const getDeckComments = (deckId) =>
  db.collection("deckDetails").doc(deckId).get().then(function(doc) {
    if (doc.exists) {
      return doc.data();
    } else {
      console.log("No such document!");
    }
  });

export const postDeckComment = (deckId, commentObj) =>
db.collection("deckDetails").doc(deckId).update({
  Comments: commentObj
}).then(function() {
    console.log("Document successfully updated!");
})
.catch(function(error) {
    console.error("Error updating document: ", error);
});

export const upVoteDeck = (deckId, votes, voters) =>
db.collection("deckDetails").doc(deckId).update({
  upVotes: votes,
  voters: voters
}).then(function() {
    console.log("Document successfully updated!");
})
.catch(function(error) {
    console.error("Error updating document: ", error);
});

// Tournament APIs
export const updateUserTournaments = (id, tournaments) =>
  db.collection("users").doc(id).update({
    tournaments: tournaments
  }).then(function() {
      console.log("Document successfully updated!");
  })
  .catch(function(error) {
      console.error("Error updating document: ", error);
  });

export const getTournaments = () =>
  db.collection("tournaments").get().then(function(querySnapshot) {
        return querySnapshot;
    });



// WEBPACK FOOTER //
// ./src/firebase/db.js